export default "__VITE_ASSET__e228669a__"